import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../axiosBaseQuery";
import type { Response } from "../interfaces";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    login: builder.mutation<
      Response<{ accessToken: string; refreshToken: string }>,
      { email: string; password: string }
    >({
      query: (credentials) => ({
        url: "auth/admin_login",
        method: "POST",
        data: credentials,
      }),
    }),

    loginWithGoogle: builder.mutation<
      Response<{ accessToken: string; refreshToken: string }>,
      { code: string; scope: string }
    >({
      query: (credentials) => ({
        url: "auth/google",
        method: "POST",
        data: credentials,
      }),
    }),

    loginWithMicrosoft: builder.mutation<
      Response<{ accessToken: string; refreshToken: string }>,
      { code: string }
    >({
      query: (credentials) => ({
        url: "auth/microsoft",
        method: "POST",
        data: credentials,
      }),
    }),

  }),
});

export const { useLoginMutation, useLoginWithGoogleMutation, useLoginWithMicrosoftMutation } = authApi;
